import { render, staticRenderFns } from "./PostHistories.vue?vue&type=template&id=0eb90b1d&scoped=true"
import script from "./PostHistories.vue?vue&type=script&lang=js"
export * from "./PostHistories.vue?vue&type=script&lang=js"
import style0 from "./PostHistories.vue?vue&type=style&index=0&id=0eb90b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb90b1d",
  null
  
)

export default component.exports